import React, { createContext, useState } from 'react';
import { useGoogleTagManager } from '../../customHooks/googleTagManager';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
export const GoogleTagManagerProvider = (props) => {
    const { args, children } = props;
    const [state, setState] = useState({});
    useGoogleTagManager({ args });
    return React.createElement(Provider, { value: { state, setState } }, children);
};
//# sourceMappingURL=index.js.map